<div class="text-sm text-gray-500 text-primary p-2 flex-1 mt-4">
  <strong>Total de registros: </strong> {{ totalElements }}
</div>
<nav class="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0 pb-5">
  <div class="-mt-px flex w-0 flex-1">
    <button
      (click)="previousPage()"
      [disabled]="currentPage() === 1"
      [ngClass]="{'opacity-50 cursor-not-allowed': currentPage() === 1}"
      class="inline-flex items-center border-t-2 border-transparent pt-4 pr-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 cursor-pointer"
    >
      <svg class="mr-3 size-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
        <path
          fill-rule="evenodd"
          d="M18 10a.75.75 0 0 1-.75.75H4.66l2.1 1.95a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 1 1 1.02 1.1l-2.1 1.95h12.59A.75.75 0 0 1 18 10Z"
          clip-rule="evenodd"
        />
      </svg>
      Anterior
    </button>
  </div>

  <div class="hidden sm:-mt-px sm:flex">
    <button
      *ngFor="let page of visiblePages"
      (click)="goToPage(page)"
      [class]="page === currentPage() ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
      class="inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium cursor-pointer"
    >
      {{ page }}
    </button>
    <span *ngIf="showEllipsis" class="inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-500">...</span>
  </div>
  
  <div class="-mt-px flex w-0 flex-1 justify-end">
    <button
      (click)="nextPage()"
      [disabled]="currentPage() === totalPages"
      [ngClass]="{'opacity-50 cursor-not-allowed': currentPage() === totalPages}"
      class="inline-flex items-center border-t-2 border-transparent pt-4 pl-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 cursor-pointer"
    >
      Siguiente
      <svg class="ml-3 size-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
        <path
          fill-rule="evenodd"
          d="M2.75 10a.75.75 0 0 1 .75-.75h12.59l-2.1-1.95a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.1-1.95H3.5A.75.75 0 0 1 2.75 10Z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
  </div>
</nav>